import React from 'react';
import Modal from '@vestingSafe/src/Components/Modal';
import styles from './styles.module.scss';
import icCloseIcon from '/assets/svg/ic_close_2.svg';
import icThg from 'assets/img/thetan_gem_V2.png';
import Button_V2 from '@vestingSafe/src/Components/Button_V2';
import { useTypedDispatch, useTypedSelector } from '@vestingSafe/src/redux/utils';
import { fetchClaimVestingSafe, fetchVestingSafeRemainingClaim } from '@vestingSafe/src/redux/actions';
import { CurrencyType, formatCurrency } from '@wolffun/system-currency';
import classNames from 'classnames';
import { AppError } from '@vestingSafe/src/redux/types';
import { BN } from 'bn.js';

const ModalClaimExtra = ({
  onClose,
  claimAmount,
  feePercentage,
  feeAmount,
  onError,
  onSuccess
}) => {
  const dispatch = useTypedDispatch();
  const {
    loading
  } = useTypedSelector(state => state.claimVestingSafe);
  const claimAmountBN = new BN((claimAmount === null || claimAmount === void 0 ? void 0 : claimAmount.value) || '');
  const feeAmountBN = new BN((feeAmount === null || feeAmount === void 0 ? void 0 : feeAmount.value) || '');
  const totalClaimable = {
    token: CurrencyType.GTHG,
    value: claimAmountBN.add(feeAmountBN).toString()
  };

  const onClaimClick = async () => {
    const {
      error
    } = await dispatch(fetchClaimVestingSafe());

    if (error !== undefined && error !== AppError.NO_ERROR) {
      onError(error);
      return;
    }

    onSuccess();
    dispatch(fetchVestingSafeRemainingClaim()); // Check how many claimable times left
  };

  return /*#__PURE__*/React.createElement(Modal, null, /*#__PURE__*/React.createElement("div", {
    className: styles.modal
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.title
  }, /*#__PURE__*/React.createElement("span", null, "Extra Vesting")), /*#__PURE__*/React.createElement("button", {
    className: styles.close,
    onClick: onClose
  }, /*#__PURE__*/React.createElement("img", {
    src: icCloseIcon
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.body
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.description
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.claimFee
  }, "A ", feePercentage, "% fee\xA0"), /*#__PURE__*/React.createElement("span", null, " will be charged for this extra vesting")), /*#__PURE__*/React.createElement("div", {
    className: styles.claimInfo
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.label
  }, /*#__PURE__*/React.createElement("span", null, "Amount")), /*#__PURE__*/React.createElement("div", {
    className: styles.value
  }, /*#__PURE__*/React.createElement("img", {
    src: icThg,
    alt: ""
  }), /*#__PURE__*/React.createElement("span", null, claimAmount ? formatCurrency(claimAmount, {
    withCurrency: true
  }) : '0'))), /*#__PURE__*/React.createElement("div", {
    className: styles.claimInfo
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.label
  }, /*#__PURE__*/React.createElement("span", null, "Fee (", feePercentage, "%)")), /*#__PURE__*/React.createElement("div", {
    className: styles.value
  }, /*#__PURE__*/React.createElement("img", {
    src: icThg,
    alt: ""
  }), /*#__PURE__*/React.createElement("span", null, feeAmount ? formatCurrency(feeAmount, {
    withCurrency: true
  }) : '0'))), /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.claimInfo, styles.total)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.label
  }, /*#__PURE__*/React.createElement("span", null, "Total")), /*#__PURE__*/React.createElement("div", {
    className: styles.value
  }, /*#__PURE__*/React.createElement("img", {
    src: icThg,
    alt: ""
  }), /*#__PURE__*/React.createElement("span", null, totalClaimable ? formatCurrency(totalClaimable, {
    withCurrency: true
  }) : '0'))), /*#__PURE__*/React.createElement("div", {
    className: styles.buttonGroup
  }, /*#__PURE__*/React.createElement(Button_V2, {
    className: styles.button,
    title: "Cancel",
    type: "secondary",
    onClick: onClose
  }), /*#__PURE__*/React.createElement(Button_V2, {
    className: classNames(styles.button, styles.claim),
    loading: loading,
    onClick: onClaimClick,
    title: /*#__PURE__*/React.createElement("div", {
      className: styles.buttonContent
    }, /*#__PURE__*/React.createElement("span", null, "Claim"), /*#__PURE__*/React.createElement("img", {
      src: icThg,
      alt: ""
    }), /*#__PURE__*/React.createElement("span", {
      className: styles.value
    }, totalClaimable ? formatCurrency(totalClaimable, {
      withCurrency: true
    }) : '0'))
  })))));
};

export default ModalClaimExtra;